import { useState, useEffect } from 'react';
import axios from 'axios';
import { CalendarDays, MapPin, Users, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
const fmtTime = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  const ampm = h >= 12 ? 'pm' : 'am';
  const hh = h % 12 || 12;
  return m ? `${hh}:${String(m).padStart(2, '0')}${ampm}` : `${hh}${ampm}`;
};

export default function FieldEventsSection({ jobId }) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    setEvents([]);
    axios.get(`${API}/jobs/${jobId}/field-events`).then((r) => setEvents(r.data)).catch(() => setEvents([]));
  }, [jobId]);

  if (events.length === 0) return null;

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-testid="job-field-events-section">
      <div className="px-5 py-3 border-b border-slate-200 flex items-center gap-2">
        <CalendarDays size={16} className="text-sky-600" />
        <h3 className="font-bold text-slate-900">Field Calendar Events ({events.length})</h3>
      </div>
      <div className="divide-y divide-slate-100">
        {events.map((ev) => {
          const end = ev.end_date || ev.date;
          return (
            <div key={ev.id} className="px-5 py-3" data-testid={`job-field-event-${ev.id}`}>
              <p className="text-sm font-semibold text-slate-900">{ev.title}</p>
              <div className="flex flex-wrap gap-x-4 gap-y-0.5 mt-1 text-xs text-slate-500">
                <span className="flex items-center gap-1">
                  <Clock size={11} />
                  {ev.date === end ? fmtDate(ev.date) : `${fmtDate(ev.date)} → ${fmtDate(end)}`}
                  {' · '}{ev.all_day ? 'All day' : `${fmtTime(ev.start_time)} – ${fmtTime(ev.end_time)}`}
                </span>
                {(ev.location || ev.lsd) && <span className="flex items-center gap-1"><MapPin size={11} /> {[ev.location, ev.lsd].filter(Boolean).join(' · ')}</span>}
                {(ev.attendee_names || []).length > 0 && (
                  <span className="flex items-center gap-1"><Users size={11} /> {ev.attendee_names.join(', ')}</span>
                )}
              </div>
              {ev.notes && <p className="mt-1 text-xs text-slate-500 whitespace-pre-wrap line-clamp-2">{ev.notes}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
